module.exports = __webpack_public_path__ + "img/boardroom.44d911f9.jpg";